import { render, staticRenderFns } from "./single-pledge.vue?vue&type=template&id=242a7aa6&scoped=true"
import script from "./single-pledge.vue?vue&type=script&lang=ts"
export * from "./single-pledge.vue?vue&type=script&lang=ts"
import style0 from "./single-pledge.vue?vue&type=style&index=0&id=242a7aa6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a7aa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242a7aa6')) {
      api.createRecord('242a7aa6', component.options)
    } else {
      api.reload('242a7aa6', component.options)
    }
    module.hot.accept("./single-pledge.vue?vue&type=template&id=242a7aa6&scoped=true", function () {
      api.rerender('242a7aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/payment-form/pledge-selector/single-pledge.vue"
export default component.exports